import { config } from 'src/config';

import type { Path } from '../types';

export function cleanHref(href: Path) {
  return decodeURIComponent(
    href.replace(new RegExp(`^/(${config.i18n.locales.join('|')})(?=/)`), ''),
  );
}
